export default __webpack_public_path__ + "static/media/no.bcaa4160.svg";